
    /** Generated by webpack-jst-loader */
    (function() {
      window.JST || (window.JST = {});
      window.JST["app_base/components/timeline/templates/timeline_unit"] = Handlebars.template({"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var helper, alias1=depth0 != null ? depth0 : (container.nullContext || {}), alias2=container.hooks.helperMissing, alias3="function", alias4=container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<div class='unit_container'>\n  <div class='date_number'>\n    "
    + alias4(((helper = (helper = lookupProperty(helpers,"date_number") || (depth0 != null ? lookupProperty(depth0,"date_number") : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"date_number","hash":{},"data":data,"loc":{"start":{"line":3,"column":4},"end":{"line":3,"column":19}}}) : helper)))
    + "\n  </div>\n  <div class='date_letter'>\n    "
    + alias4(((helper = (helper = lookupProperty(helpers,"date_letter") || (depth0 != null ? lookupProperty(depth0,"date_letter") : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"date_letter","hash":{},"data":data,"loc":{"start":{"line":6,"column":4},"end":{"line":6,"column":19}}}) : helper)))
    + "\n  </div>\n  <div class='bar_container'>\n    <div class='bar'></div>\n  </div>\n</div>\n";
},"useData":true});
    }).call(this);
  